import React from 'react';
import PropTypes from 'prop-types';
import { useRequestData, useLabels, usePrefs } from 'wsm-common-data';
import { setClassNames } from 'ddc-classnames-js';
import { trackEvent } from 'ddc-track-event';
import { MyCarsButtons } from 'wsm-mycars-buttons';
import CompareCheckbox from './CompareCheckbox';
import { publishVehicleData } from '../utilities/vehicleTracking';

const FooterContainer = ({
	shouldShowCompare,
	isMyCarsSitePropEnabled,
	link,
	uuid
}) => {
	const labels = useLabels();
	const { windowId, widgetName } = useRequestData();
	const { mycarsSaveLabel, mycarsSavedLabel } = usePrefs();
	return (
		<div
			className={setClassNames([
				'vehicle-card-footer',
				'd-flex',
				'flex-wrap',
				'align-items-center'
			])}
		>
			{shouldShowCompare && <CompareCheckbox uuid={uuid} />}
			{isMyCarsSitePropEnabled && (
				<MyCarsButtons
					key="MyCarsButtonComponent"
					uuid={uuid}
					isLink
					{...{
						mycarsSaveLabel,
						mycarsSavedLabel
					}}
				/>
			)}
			<a
				className="more-details-link ml-auto text-link text-link-muted btn-small"
				href={link}
				onClick={() => {
					trackEvent(widgetName, windowId, {
						element: 'View details link',
						result: 'Navigated to VDP'
					});
					publishVehicleData(uuid);
				}}
			>
				{labels.get('MORE_DETAILS')}
				<i className="ddc-icon ddc-icon-arrow1-right text-primary pl-3" />
			</a>
		</div>
	);
};

FooterContainer.propTypes = {
	shouldShowCompare: PropTypes.bool.isRequired,
	isMyCarsSitePropEnabled: PropTypes.bool.isRequired,
	mycarsSaveLabel: PropTypes.string,
	mycarsSavedLabel: PropTypes.string,
	uuid: PropTypes.string.isRequired,
	link: PropTypes.string.isRequired
};

FooterContainer.defaultProps = {
	mycarsSaveLabel: 'SAVE',
	mycarsSavedLabel: 'SAVED_BANG'
};

export default FooterContainer;
